// Helpers de vista previa de piezas compartidos entre ReporteKpisMarketing y AgenteMarketing.
// getVimeoSrc acepta una URL de Vimeo, un ID numerico o un <iframe> pegado completo
// (asi es como marketing.php guarda embed_vimeo) y siempre devuelve una URL de player.vimeo.com.
export const getVimeoSrc = (raw) => {
  if (!raw) return null
  raw = raw.trim()
  if (/<iframe/i.test(raw)) {
    const m = raw.match(/src=["']([^"']+)["']/)
    if (m) return m[1].split('?')[0] + '?muted=1&autoplay=1&loop=1&background=0&autopause=0'
  }
  const m = raw.match(/vimeo\.com\/(?:video\/)?(\d+)/)
  let id = m ? m[1] : (/^\d+$/.test(raw) ? raw : null)
  if (!id) return null
  return `https://player.vimeo.com/video/${id}?muted=1&autoplay=1&loop=1&background=0&autopause=0`
}

export const getTikTokEmbedSrc = (idExterno) => idExterno ? `https://www.tiktok.com/embed/v2/${idExterno}?autoplay=1&muted=1` : null
